import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/nursery/api';

function BranchSelector({ currentBranch, onBranchChange, branches: propBranches }) {
    const [branches, setBranches] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (propBranches && propBranches.length > 0) {
            setBranches(propBranches);
        } else {
            fetchBranches();
        }
    }, [propBranches]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchBranches = async () => {
        try {
            const response = await axios.get(`${API_URL}/branches`);
            console.log('Branches from API:', response.data);
            setBranches(response.data);
        } catch (error) {
            console.error('Error fetching branches:', error);
            setBranches([
                { id: 1, branch_code: 'SHJ01', branch_name: 'NASMAT AL ZOHOUR - SHARJAH', address: 'Al Zohour Nursery, Industrial Area, Sharjah', phone: '+971552698951' },
                { id: 2, branch_code: 'DXB01', branch_name: 'NASMAT AL ZOHOUR - DUBAI', address: 'Al Warsan 3, Dubai', phone: '+971526629183' }
            ]);
        }
    };

    const handleBranchSelect = (branch) => {
        onBranchChange(branch);
        setShowDropdown(false);
        localStorage.setItem('selectedBranchId', branch.id);
        localStorage.setItem('selectedBranchName', branch.branch_name);
    };

    if (!currentBranch) return null;

    // Get display text (prioritize address)
    const getDisplayText = (branch) => {
        if (branch.address) return branch.address;
        return branch.branch_name;
    };

    return (
        <div ref={dropdownRef} style={styles.container}>
            <button 
                style={styles.branchButton}
                onClick={() => setShowDropdown(!showDropdown)}
            >
                <span style={styles.branchIcon}>📍</span>
                <span style={styles.branchName}>
                    {getDisplayText(currentBranch)?.length > 30 
                        ? getDisplayText(currentBranch).substring(0, 27) + '…' 
                        : getDisplayText(currentBranch)}
                </span>
                <span style={{ ...styles.chevron, transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                    ▼
                </span>
            </button>

            {showDropdown && (
                <div style={styles.dropdown}>
                    {branches.map(branch => (
                        <div
                            key={branch.id}
                            style={{
                                ...styles.branchOption,
                                ...(currentBranch?.id === branch.id ? styles.branchOptionActive : {})
                            }}
                            onClick={() => handleBranchSelect(branch)}
                        >
                            <div style={styles.branchOptionIcon}>🏪</div>
                            <div style={styles.branchOptionInfo}>
                                {/* Show ADDRESS as main text */}
                                <div style={styles.branchOptionName}>
                                    {branch.address || branch.branch_name}
                                </div>
                                {/* Show branch name and code as secondary */}
                                <div style={styles.branchOptionCode}>
                                    {branch.branch_name} ({branch.branch_code})
                                </div>
                                {branch.phone && (
                                    <div style={styles.branchOptionPhone}>
                                        📞 {branch.phone}
                                    </div>
                                )}
                            </div>
                            {currentBranch?.id === branch.id && (
                                <span style={styles.checkMark}>✓</span>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

const styles = {
    container: { position: 'relative', minWidth: '200px' },
    branchButton: {
        display: 'flex', alignItems: 'center', gap: '8px',
        padding: '8px 14px', background: '#64748b', color: 'white',
        border: 'none', borderRadius: '8px', cursor: 'pointer',
        fontSize: '12px', fontWeight: '500', width: '100%',
        justifyContent: 'space-between', transition: 'all 0.2s'
    },
    branchIcon: { fontSize: '14px' },
    branchName: { 
        flex: 1, textAlign: 'left', fontSize: '12px', 
        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' 
    },
    chevron: { fontSize: '10px', transition: 'transform 0.2s' },
    dropdown: {
        position: 'absolute', top: 'calc(100% + 8px)', left: 0, right: 0,
        background: 'white', borderRadius: '12px', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)',
        zIndex: 1000, maxHeight: '320px', overflowY: 'auto', border: '1px solid #e2e8f0'
    },
    branchOption: {
        padding: '12px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9',
        display: 'flex', alignItems: 'center', gap: '12px', transition: 'background 0.2s'
    },
    branchOptionActive: { background: '#f0fdf4' },
    branchOptionIcon: { fontSize: '20px' },
    branchOptionInfo: { flex: 1 },
    branchOptionName: { fontWeight: '600', fontSize: '13px', color: '#1e293b', lineHeight: '1.3' },
    branchOptionCode: { fontSize: '10px', color: '#64748b', marginTop: '3px' },
    branchOptionPhone: { fontSize: '9px', color: '#10b981', marginTop: '2px' },
    checkMark: { color: '#10b981', fontWeight: 'bold', fontSize: '14px' }
};

export default BranchSelector;
